// Testimonials block schema - Quote cards with author info
export const testimonialsSchema = {
  type: 'testimonials',
  label: 'Testimonials',
  description: 'Quote cards showcasing reviews and testimonials',
  icon: 'Quote',
  defaultContent: {
    heading: 'What People Say',
    layout: 'grid', // 'grid' | 'carousel' (carousel can be added later)
    style: {},
    items: [
      {
        id: 'testimonial_1',
        quote: 'Add a testimonial quote here. Share what your clients or students have said about your services.',
        author: 'Student Name',
        role: 'Chess Student',
        avatar: '',
      },
    ],
  },
  fields: [
    { name: 'heading', label: 'Section Heading', type: 'text', placeholder: 'What People Say' },
    { name: 'items', label: 'Testimonials', type: 'array' },
  ],
};
